import { useTranslations } from 'use-intl';

import { Button } from '@/shared-ui';

interface Props {
  isVisible: boolean;
  onResume: () => void;
  title?: string;
  message?: string;
  buttonText?: string;
}

export default function ProjectUsabilityTimeoutOverlay({
  isVisible,
  onResume,
  title,
  message,
  buttonText,
}: Props) {
  const t = useTranslations('Usability');

  if (!isVisible) {
    return null;
  }

  const resolvedTitle = title ?? t('sessionPausedTitle');
  const resolvedMessage = message ?? t('sessionPausedMessage');
  const resolvedButtonText = buttonText ?? t('sessionPausedButton');

  return (
    <div
      data-test='usability-timeout-overlay'
      className='fixed inset-0 z-50 flex items-center justify-center bg-black/50'
    >
      <div className='mx-4 max-w-100 rounded-lg bg-white p-6 shadow-xl'>
        <div className='text-center'>
          <div className='mb-4'>
            <div className='mx-auto mb-2 flex size-12 items-center justify-center rounded-full bg-yellow-100'>
              <div className='size-6 animate-pulse rounded-full bg-yellow-500' />
            </div>
            <h3 className='text-lg font-semibold text-gray-900'>
              {resolvedTitle}
            </h3>
          </div>

          <p className='mb-4 text-sm text-gray-600'>{resolvedMessage}</p>

          <Button
            onClick={onResume}
            className='inline-flex items-center gap-2 px-4 py-2'
            data-test='usability-timeout-resume-button'
          >
            {resolvedButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
}
